

export const addLetterSofPlural = (arrayLength: number): string => arrayLength > 1 ? "s" : ""